import { fetchYamlByGet, noResponseYamlPut } from './execute';
import { getParams } from '../reducers/analyticsApp';

export const updateMapping = (code) => (dispatch, getState) =>
  noResponseYamlPut('/metainf/mapping', code, getParams(getState())).then(() => ({ code }));

export const fetchMapping = () => (dispatch, getState) =>
  fetchYamlByGet('/metainf/mapping', getParams(getState())).then((response) => ({
    code: response,
  }));
